var getConfigFromDom;

module.exports = getConfigFromDom = function(id) {
  var elt, error, text;
  if (id == null) {
    id = 'domConfig';
  }
  elt = document.getElementById(id);
  if (!elt) {
    return {};
  }
  text = elt.textContent || elt.innerText;
  try {
    return JSON.parse(text);
  } catch (error1) {
    error = error1;
    error.message += '\n     Attempted to parse: ' + text;
    throw error;
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy9nZXRDb25maWdGcm9tRG9tLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9qcHZlcmRlam8vR3JvdXBvbi9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvZ2V0Q29uZmlnRnJvbURvbS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsSUFBQTs7QUFBQSxNQUFNLENBQUMsT0FBUCxHQUFpQixnQkFBQSxHQUFtQixTQUFDLEVBQUQ7QUFDbEMsTUFBQTs7SUFEbUMsS0FBSzs7RUFDeEMsR0FBQSxHQUFNLFFBQVEsQ0FBQyxjQUFULENBQXdCLEVBQXhCO0VBQ04sSUFBYSxDQUFDLEdBQWQ7QUFBQSxXQUFPLEdBQVA7O0VBQ0EsSUFBQSxHQUFPLEdBQUcsQ0FBQyxXQUFKLElBQW1CLEdBQUcsQ0FBQztBQUk5QjtXQUNFLElBQUksQ0FBQyxLQUFMLENBQVcsSUFBWCxFQURGO0dBQUEsY0FBQTtJQUVNO0lBQ0osS0FBSyxDQUFDLE9BQU4sSUFBaUIsNkJBQUEsR0FBZ0M7QUFDakQsVUFBTSxNQUpSOztBQVBrQyJ9
